// extracted by css-extract-rspack-plugin
export default {"linkWrapper":"Tee8Z","modelTitle":"Hc2zy"};